











































import { Vue, Component, Prop } from "vue-property-decorator";
import DetailsDialog from "./Dialogs/DetailsDialog.vue";
import * as temp from "../_store/temp.module";
import { bus } from "../main";
import * as data from "../_store/data.module";
import * as user from "../_store/user.module";

@Component({
  components: {
    DetailsDialog
  }
})
export default class AssignEnterprise extends Vue {
  @Prop() params!: any;
  @Prop() idIscrizioneAttivita!: number;
  @Prop() idRichiesta!: number;
  @Prop() info!: any;
  @Prop() activityType!: string;

  private searchEnterprise: string;
  private listaRichieste: any;
  private headers: any;
  private loadingData: boolean;
  //   private activitytype: string;

  constructor() {
    super();
    this.searchEnterprise = "";
    this.listaRichieste = [];
    this.loadingData = true;
    // this.activitytype = "";
    this.headers = [
      {
        text: "Azienda",
        value: "denominazioneAzienda"
      },
      {
        text: "Luogo Svolgimento",
        value: "comuneTirocinio"
      },
      {
        text: "Nome Tirocinante Indicato",
        value: "nomeTirocinante"
      },
      {
        text: "Cognome Tirocinante Indicato",
        value: "cognomeTirocinante"
      },
      {
        text: "Dettagli Disponibilità",
        value: "details"
      },
      {
        text: "Assegna",
        value: "assignEnterprise"
      }
    ];
  }

  loadSectorRequests() {
    var payload = {
      idIscrizioneAllievo: this.idIscrizioneAttivita
    };
    this.listaRichieste = [];
    data
      .dispatchRichiesteAttivita(this["$store"], payload)
      .then(result => {
        this.listaRichieste = result;
        this.loadingData = false;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  assignEnterprise(idRichiesta: number, idRichiestaOld: number) {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var userInfo = user.readUserInfo(this["$store"]);
    if (idRichiestaOld === null || idRichiestaOld === undefined) {
      idRichiestaOld = 0;
    }
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico,
      idAllievo: this.info.idUtente,
      idTutor: userInfo.idUtente,
      // idTutor:"",
      idRichiesta: idRichiesta,
      idRichiestaOld: idRichiestaOld,
      attivita: ""
    };
    var payload2 = {
      idAllievo: this.info.idUtente,
      idAnnoScolastico: idAnnoScolastico,
      idIstituto: instituteInfo.id
    };
    if (this.activityType === "alternanza") {
      payload.attivita = "alternanza";
      data
        .dispatchDetailsAbbinamentoTutorAllievo(this["$store"], payload2)
        .then(result => {
          payload.idTutor = result.IdTutorArticolazione;
          user
            .dispatchAssignAllievoToAzienda(this["$store"], payload)
            .then(() => {
              bus.$emit(
                "successfullOperation",
                "Assegnazione avvenuta con successo"
              );
              bus.$emit("loadStudentsTutor");
              bus.$emit("loadSectorRequests");
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", error.response.statusText);
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", error.response.statusText);
              }
            });
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else if (this.activityType === "tirocinioEstivo") {
      payload.attivita = "tirocinioEstivo";
      data
        .dispatchDetailsAbbinamentoTutorAllievo(this["$store"], payload2)
        .then(result => {
          payload.idTutor = result.IdTutorArticolazione;
          user
            .dispatchAssignAllievoToAziendaTirEstivo(this["$store"], payload)
            .then(() => {
              bus.$emit(
                "successfullOperation",
                "Assegnazione avvenuta con successo"
              );
              bus.$emit("loadStudentsTutor");
              bus.$emit("loadSectorRequests");
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", error.response.statusText);
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", error.response.statusText);
              }
            });
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else if (this.activityType === "tirocinioFormativo") {
      payload.attivita = "tirocinioFormativo";
      data
        .dispatchDetailsAbbinamentoTutorAllievo(this["$store"], payload2)
        .then(result => {
          payload.idTutor = result.IdTutorArticolazione;
          user
            .dispatchAssignAllievoToAziendaTirFormativo(this["$store"], payload)
            .then(() => {
              bus.$emit(
                "successfullOperation",
                "Assegnazione avvenuta con successo"
              );
              bus.$emit("loadStudentsTutor");
              bus.$emit("loadSectorRequests");
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", error.response.statusText);
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", error.response.statusText);
              }
            });
        });
    } else if (this.activityType === "tirocinioReIns") {
      payload.attivita = "tirocinioReIns";
      data
        .dispatchDetailsAbbinamentoTutorAllievo(this["$store"], payload2)
        .then(result => {
          payload.idTutor = result.IdTutorArticolazione;
          user
            .dispatchAssignAllievoToAziendaTirFormativo(this["$store"], payload)
            .then(() => {
              bus.$emit(
                "successfullOperation",
                "Assegnazione avvenuta con successo"
              );
              bus.$emit("loadStudentsTutor");
              bus.$emit("loadSectorRequests");
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", error.response.statusText);
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", error.response.statusText);
              }
            });
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Errore nella procedura di assegnazione azienda"
      );
    }
  }

  created() {
    this.loadSectorRequests();
  }
}
